import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssetsFleetManagementListComponent } from './assets-fleet-management-list/assets-fleet-management-list.component';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { AssetsDriverRoutingModule } from '../my-assets-driver/assets-driver-routing.module';
import { AssetDriverDetailComponent } from '../my-assets-driver/asset-driver-detail/asset-driver-detail.component';
import { AssetDetailComponent } from '../my-assets/asset-detail/asset-detail.component';

const routes: Routes = [
  {
    path: 'asset-fleet-management-list',
    canActivate: [AuthorizeGuard],
    children: [
      { path: '', component: AssetsFleetManagementListComponent },
      { path: ':id', component: AssetDriverDetailComponent },
      { path: 'journey/:id', component: AssetDetailComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), AssetsDriverRoutingModule],
  exports: [RouterModule],
  providers: [],
})
export class AssetsFleetManagementRoutingModule {}
